module.exports = __webpack_public_path__ + "img/ICN_Logo.04a49251.png";